






































import Vue from "vue";
export default {
  name: "aiwen-psd-graph",
  data() {
    return {
      graphCode: "",
      isRefresh: false,
    };
  },
  props: ["graph"],
  watch: {
    graph: {
      handler: function(newCul: any, oldCul: any) {
        if (newCul != oldCul) {
          (this as any).isRefresh = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    refresh() {
      (this as any).isRefresh = true;
      (this as any).$emit("re-graph");
    },
    reLogin() {
      if (!(this as any).graphCode) return;
      (this as any).$emit("re-login", (this as any).graphCode);
    },
    close() {
      (this as any).$emit("close-graph");
    },
  },
};
